<template>
  <div>
    <v-btn
      tile
      depressed
      color="secondary"
      v-bind="$attrs"
      @click="downloadOrderReport()"
    >
      {{ $t('admin.downloadOrderReport') }}
    </v-btn>
  </div>
</template>

<script>
import { getProviderDetails } from '@/utils/PaymentProviderHelper';
import { formatDate } from '@/helpers/generalFunctions';

export default {
  name: "DownloadOrderReportButton",
  props: {
    orderData: {
      type: Array,
      required: true,
    },
  },
  computed: {
    fileName() {
      const date = new Date().toLocaleDateString().replaceAll('/', '_');
      return "order_report_" + date + ".csv";
    },
  },
  methods: {
    downloadOrderReport() {
      if (!this.orderData?.length) return;

      const rows = [];
      const rowHeaders = [
        this.$t('csvHeaders.orderId'),
        this.$t('csvHeaders.orderNumber'),
        this.$t('csvHeaders.orderDate'),
        this.$t('transactionReports.customer'),
        this.$t('csvHeaders.event'),
        this.$t('csvHeaders.resolution'),
        this.$t('csvHeaders.fulfillmentStatus'),
        this.$t('csvHeaders.quantity'),
        this.$t('transactionReports.totalPrice'),
        this.$t('csvHeaders.baseCurrency'),
        this.$t('csvHeaders.provider'),
      ];
      rows.push(rowHeaders);

      this.orderData.forEach(order => {
        const dateString = order.updatedAt ? formatDate(order.updatedAt) : '';
        const providerDetails = getProviderDetails(order);
        const quantity = order.orderLines?.edges?.reduce(
          (acc, edge) => acc + edge.node.quantity, 0
        ) ?? 0;
        const statusLabel = order.fulfillmentStatus
          ? this.$t('transactionReports.statuses.' + order.fulfillmentStatus)
          : this.$t('common.none');

        const row = [
          order._id,
          "\"" + (order.orderNumber ?? this.$t('common.none')) + "\"",
          "\"" + dateString + "\"",
          "\"" + (order.customerEmail ?? order.customerId ?? '') + "\"",
          "\"" + (order.event?.name ?? this.$t('common.none')) + "\"",
          order.resolution ?? '',
          "\"" + statusLabel + "\"",
          quantity,
          order.currency?._id + " " + order.totalPriceSet,
          order.currency?._id ?? '',
          providerDetails?.provider ?? this.$t('common.none'),
        ];
        rows.push(row);
      });

      const csvContent = "data:text/csv;charset=utf-8," + rows.join("\n");
      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", this.fileName);
      link.click();
    },
  },
}
</script>
